import sdl from '@jds/react-generated-sdl/JDSModalMobileInternal';
import type { JDSModalMobileInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSModalMobileInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dialog',
    size = 'medium',
    headerAlignment = 'left',
    isCloseable = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    ariaLabel = 'Modal Content',
    cancelButtonCtaAriaLabel = 'Close Modal',
    _ariaModal = 'true',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      size,
      headerAlignment,
      isCloseable,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ariaLabel,
      cancelButtonCtaAriaLabel,
      _ariaModal,
      ...rest
    },
    'JDSModalMobileInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ModalMobileInternal = withLogic(
  Component
) as React.FC<JDSModalMobileInternalProps> & { slotName?: string };

ModalMobileInternal.displayName = 'ModalMobileInternal';
ModalMobileInternal.slotName = 'jds_modal_mobile_internal';

export { ModalMobileInternal, type JDSModalMobileInternalProps };
